import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import BackBtn from "../../images/backButton.svg";
import CloseImg from "../../images/close.svg"
function RedirectCommonModal(props) {
   
    const{heading, para, link, hide} = props

    const handleClose = ()=>{
      if(hide){
        hide()
      }
    }

  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={()=>{handleClose()}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className="w-full max-w-md transform overflow-hidden rounded-md bg-[#e7e7e9] p-4 pt-2 text-left align-middle shadow-xl transition-all"
                >
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  ></Dialog.Title>
                  <div className="doc-modal flex-col items-center justify-center mt-2">
                    <div className="flex justify-center items-center"></div>
                    <div className="flex items-center justify-between gap-4">
                      <div>
                        <div>
                          <div className="head" style={{color:"#232345"}}>{heading}</div>
                          <div className="text-sm mt-1"style={{color:"#232345"}}>
                           {para}
                          </div>
                        </div>
                      </div>

                     {link ? <Link to={link}>
                        <img
                          className="p-4 rounded-md bg-[#3e3c43]"
                          src={BackBtn}
                          alt=""
                        />
                      </Link>:
                      <button onClick={()=>handleClose()} className="bg-white hover:bg-gray-400 p-2 rounded"><img className="w-6" src={CloseImg}  /></button>
                      }
                    </div>
                  </div>

                  <div className="absolute top-2 right-2 "></div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default RedirectCommonModal;
